<template>
  <!-- d-flex align-center flex-wrap needed for Vuetify 4: fill-height no longer centers content -->
  <v-container class="fill-height d-flex align-center flex-wrap" fluid>
    <v-empty-state
      class="w-100 align-center justify-center"
      v-if="!hasData && !loading"
      @click:action="goBack"
      action-text="Go Back"
    >
      <template v-slot:headline>
        <div class="text-h1">404</div>
      </template>
      <template v-slot:title> Page Not Found </template>
      The page you were looking for does not exist
    </v-empty-state>
  </v-container>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
